import { useEffect } from 'react';

function upsertMeta(attribute, key, content) {
    let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
    if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, key);
        document.head.appendChild(element);
    }
    element.setAttribute('content', content);
}

function upsertCanonical(href) {
    let element = document.head.querySelector('link[rel="canonical"]');
    if (!element) {
        element = document.createElement('link');
        element.setAttribute('rel', 'canonical');
        document.head.appendChild(element);
    }
    element.setAttribute('href', href);
}

// The prerendered HTML already ships the right head per route; this keeps
// it correct after client-side navigation between routes.
export function usePageMeta({ title, description, robots, url }) {
    useEffect(() => {
        document.title = title;
        upsertMeta('name', 'description', description);
        upsertMeta('name', 'robots', robots);
        upsertMeta('property', 'og:title', title);
        upsertMeta('property', 'og:description', description);
        upsertMeta('property', 'og:url', url);
        upsertMeta('name', 'twitter:title', title);
        upsertMeta('name', 'twitter:description', description);
        upsertCanonical(url);
    }, [title, description, robots, url]);
}
